export default __webpack_public_path__ + "static/cncf-meshery-landscape-d1e2d5b60e7f09ac7f93dd2029d7f581.webp";